export interface NoteViewModel {
  NoteId: string;
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  NoteType: string;
  IsPinned: boolean;
  IsArchived: boolean;
  IsTrashed: boolean;
  BackgroundColor: string;
  IsCheckList: boolean;
  HasReminder: boolean;
  ReminderDate: string | null;
  DisplayOrder: number | null;
  CreatedBy: string;
  CreatedDate: string;
  UpdatedAt: string;
  Tags: string;
  HasMentions: boolean;
  TotalCount: number;
  TransactionNumber?: string;
  AttachmentsJson?: string;
  MentionsJson?: string;
  Attachments?: NoteAttachment[];
  Mentions?: {MentionedUserId: string }[];
  CreatedByName: string;
  CreatedByEmail: string;
}

export interface NoteAttachment {
  AttachmentId: string;
  FileURL: string;
  FileType: string;
  UploadedBy: string;
  UploadedAt: string;
}

export interface NoteMention {
  MentionedUserId: string;
  IsNotified: boolean;
}

export interface CreateNoteViewModel {
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  NoteType: string;
  IsPinned: boolean;
  IsArchived: boolean;
  BackgroundColor: string;
  IsCheckList: boolean;
  HasReminder: boolean;
  ReminderDate: string | null;
  DisplayOrder: number | null;
  Tags: string[];
  MentionedUsers: string[];
  CompanyId?: string;
}

export interface UpdateNoteViewModel {
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  NoteType: string;
  IsPinned: boolean;
  IsArchived: boolean;
  BackgroundColor: string;
  IsCheckList: boolean;
  HasReminder: boolean;
  ReminderDate: string | null;
  DisplayOrder: number | null;
  Tags: string[];
  CompanyId?: string;
}

export interface AddAttachmentViewModel {
  NoteId: string;
  FileURL: string;
  FileType: string;
}

export interface MentionViewModel {
  MentionId: number;
  NoteId: string;
  MentionedUserId: string;
  IsNotified: boolean;
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  CreatedBy: string;
  CreatedDate: string;
}

export interface TrashedNoteViewModel {
  NoteId: string;
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  NoteType: string;
  IsPinned: boolean;
  IsArchived: boolean;
  BackgroundColor: string;
  IsCheckList: boolean;
  HasReminder: boolean;
  ReminderDate: string | null;
  DisplayOrder: number | null;
  CreatedBy: string;
  CreatedDate: string;
  UpdatedAt: string;
  Tags: string;
  TotalCount: number;
}

export interface SearchNoteResultViewModel {
  NoteId: string;
  Title: string;
  NoteContent: string;
  TransactionType: string;
  TransactionId: string;
  NoteType: string;
  IsPinned: boolean;
  CreatedDate: string;
  Tags: string;
  TotalCount: number;
}

export interface NoteFilterParams {
  SearchTerm?: string;
  TransactionType?: string;
  TransactionId?: string;
  NoteType?: string;
  IsPinned?: boolean;
  IsArchived?: boolean;
  PageNumber: number;
  PageSize: number;
  HasReminder?: boolean | null;
}

export interface GlobalSearchParams {
  SearchTerm: string;
  UserId: string;
  TransactionType?: string;
  TagName?: string;
  DateFrom?: string;
  DateTo?: string;
  PageNumber: number;
  PageSize: number;
}

export const NOTE_BG_COLORS = [
  { value: '#ffffff', label: 'White' },
  { value: '#fef9c3', label: 'Yellow' },
  { value: '#dcfce7', label: 'Green' },
  { value: '#dbeafe', label: 'Blue' },
  { value: '#fce7f3', label: 'Pink' },
  { value: '#ede9fe', label: 'Purple' },
  { value: '#ffedd5', label: 'Orange' },
  { value: '#f1f5f9', label: 'Gray' },
];


// global notes

export interface GlobalNoteFilterParams {
    filterType?: string;
    searchTerm?: string;
    tagName?: string;

    transactionType?: string;
    fromDate?: Date;
    toDate?: Date;
    createdBy?: string;
    noteType?: string;

    pageNumber: number;
    pageSize: number;
  }

export interface GlobalNoteCounts {
  AllNotes: number;
  PinnedNotes: number;
  ArchivedNotes: number;
  TrashedNotes: number;
  Reminders: number;
}

export interface UserTag {
    TagName: string;
    NoteCount: number;
}

export interface TrashedNoteGlobalViewModel {
    NoteId: string;
    Title: string;
    NoteContent: string;
    TransactionType: string;
    TransactionId: string;
    NoteType: string;
    IsPinned: boolean;
    IsArchived: boolean;
    IsTrashed: boolean;
    BackgroundColor: string;
    IsCheckList: boolean;
    HasReminder: boolean;
    ReminderDate: string | null;
    DisplayOrder: number | null;
    CreatedBy: string;
    CreatedDate: string;
    UpdatedAt: string;
    Tags: string;
    TransactionNumber: string;
    CreatedByName: string;
    CreatedByEmail: string;
    TotalCount: number;
}